import { FC } from 'react';
import classNames from 'classnames';
import swiperCss from '@edikk-edikk/country-frontend/css/modules/swiper.module.scss';
import { AdvertPhotoType } from '@edikk-edikk/country-frontend';
import galleryThumbnailCss from '../../../assets/gallery/gallery-thumbnail.module.scss';
import { PictureForPhoto } from '#advert/components/picture-for-photo';

type PropsType = {
  photo: AdvertPhotoType;
  index: number;
  isActive: boolean;
};

const Thumbnail: FC<PropsType> = ({
  photo,
  index,
  isActive,
}) => (
  <div
    className={classNames(
      swiperCss.swiper__slide,
      galleryThumbnailCss.galleryThumbnail,
      { [galleryThumbnailCss.galleryThumbnail_active]: isActive },
    )}
  >
    <PictureForPhoto
      photo={photo}
      className={galleryThumbnailCss.galleryThumbnail__image}
      alt={`Preview for photo ${index + 1}`}
      isUse100
    />
  </div>
);

export { Thumbnail };
